import _ from 'lodash';

const basicComparisonCustomizer = (val1, val2) => {
  if (_.isFunction(val1) && _.isFunction(val2)) return true;
  if (_.isObject(val1) && _.isObject(val2)) {
    const val1Values = _.values(val1).toString();
    const val2Values = _.values(val2).toString();
    return val1Values === val2Values;
  }

  return undefined;
};

const handleShouldComponentUpdate = (opts = {}) => {
  const { props, nextProps, state, nextState, customizer } = opts;
  const comparisonCustomizer = customizer || basicComparisonCustomizer;

  if (!_.isEqualWith(props, nextProps, comparisonCustomizer)) return true;
  if (!_.isEqualWith(state, nextState, comparisonCustomizer)) return true;

  return false;
};

export default handleShouldComponentUpdate;
